import BaseServiceCrud from './BaseServiceCrud';

export default class OrderFuelService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'order-fuel';
    }

    orderFuel(element) {
        const elementCopy = JSON.parse(JSON.stringify(element));
        if (elementCopy.partner) {
            delete elementCopy.partner.address;
            delete elementCopy.partner.city;
            delete elementCopy.partner.name;
        }

        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'POST',
            body: JSON.stringify(elementCopy),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getFuels(type, adBlueLpg, anwim, fuel) {
        // Get a token from api server using the fetch api
        return this.fetch(
            `${this.domain}/${this.path}/fuels/${type}${!!adBlueLpg ? '?adblue_lpg=true' : ''}${!!anwim ? '?anwim=true' : ''}${
                !!fuel ? '?fuel=true' : ''
            }`,
            {
                method: 'GET',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }

    getDeliveryPlaces() {
        return this.fetch(`${this.domain}/${this.path}/delivery-places`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getFuelBases() {
        return this.fetch(`${this.domain}/${this.path}/fuel-bases`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    remove(element) {
        return this.fetch(`${this.domain}/${this.path}/${element.petraId}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            draft: criteria.draft,
            uninvoiced: criteria.uninvoiced,
            date_from: criteria.dateFrom,
            date_to: criteria.dateTo,
            amount_from: criteria.amountFrom,
            amount_to: criteria.amountTo,
            status: criteria.status?.enumValue,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    updateTemplate(element) {
        const elementCopy = JSON.parse(JSON.stringify(element));
        if (elementCopy.partner) {
            delete elementCopy.partner.address;
            delete elementCopy.partner.city;
            delete elementCopy.partner.name;
        }

        return this.fetch(`${this.domain}/${this.path}/update-template`, {
            method: 'PUT',
            body: JSON.stringify(elementCopy),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    cancelOrder(orderId) {
        return this.fetch(`${this.domain}/${this.path}/cancel`, {
            method: 'PUT',
            body: JSON.stringify({orderId}),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    sendFinancialAuth(attachment, orderId) {
        const formData = new FormData();
        if (attachment !== null && attachment !== undefined) {
            formData.append('file', attachment);
            formData.append('file_name', attachment.name);
        }
        formData.append('orderId', orderId);
        return this.fetch(
            `${this.domain}/${this.path}/send-attachment`,
            {
                method: 'POST',
                body: formData,
            },
            {
                Accept: 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
            }
        ).then((res) => {
            return Promise.resolve(res);
        });
    }
}
